import * as React from 'react';
import { ForwardedRef } from 'react';

export interface ButtonProps extends Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'ref'> {
	type?: 'submit' | 'button';
	isLoading?: boolean;
	loadingNode?: React.ReactNode;
}

const Button = React.forwardRef(({
	type = 'submit',
	className = 'btn btn-primary',
	isLoading,
	onClick,
	children,
	title,
	disabled = false,
	loadingNode = false,
	...rest
}: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
	return <button
		{...rest}
		ref={ref}
		type={type === 'submit' ? 'submit' : 'button'}
		disabled={isLoading || disabled}
		className={`button-component ${className} ${isLoading ? 'isLoading' : ''}`}
		onClick={onClick}
		title={title}
	>
		{!!loadingNode && isLoading && loadingNode}
		<span>{children}</span>
	</button>;
});

interface PreventDefaultButtonProps extends ButtonProps {
	onClick: () => void;
}

export const PreventDefaultButton = React.forwardRef((
	{ onClick, children, ...rest }: PreventDefaultButtonProps,
	ref: ForwardedRef<HTMLButtonElement>,
) =>
	<Button
		{...rest}
		ref={ref}
		type="button"
		onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }}
	>
		{children}
	</Button>);

export default Button;
